// Module
var code = `<div class="mt-0.5"> <material-icon class="h-4 w-4" ng-show="\$ctrl.type === \$ctrl.RESOURCE_TYPE_VIDEO" name="play_circle_outline" classes="harvust-icon-orange"></material-icon> <material-icon class="h-4 w-4" ng-show="\$ctrl.type === \$ctrl.RESOURCE_TYPE_ARTICLE" name="description" classes="harvust-icon-orange"></material-icon> </div> `;
// Exports
export default code;